
import { Options, Vue }    from 'vue-class-component';

@Options({
  data(){
    return{
      tiles: [],
      yardImg: this.$store.state.screenshot,
      curbs: [],
      scarpElements: [],
      grouts: [],
      impregnation: [],
      addons: []
    }
  },
  mounted() {
    this.tiles = this.$store.state.selectedTiles
    this.curbs = (this.$store.state.curbs || []).filter(x => x.itemAdded)
    this.scarpElements = (this.$store.state.scarpElements || []).filter(x => x.itemAdded)
    this.grouts = (this.$store.state.grouts || []).filter(x => x.itemAdded)
    this.impregnation = (this.$store.state.impregnation || []).filter(x => x.itemAdded)
    this.addons = (this.$store.state.addons || []).filter(x => x.itemAdded)
  },
  methods: {
    removeItem(arr,i){
      this[arr].splice(i,1)

      const comitType = 'set' + arr.charAt(0).toUpperCase() + arr.slice(1)
      this.$store.commit(comitType,this[arr])
    }
  },
  computed: {
    allProps() {
      return `${this.tiles}|${this.curbs}|${this.scarpElements}|${this.grouts}|${this.impregnation}|${this.addons}`;
    },
  },
  watch: {
    allProps(){
      const products = this.tiles.concat(this.curbs,this.scarpElements,this.grouts,this.impregnation,this.addons)
      this.$store.commit('setProducts', products)
}
  }
})
export default class Summary extends Vue {}
